import { render, staticRenderFns } from "./work-item-form.component.vue?vue&type=template&id=c49266a0&scoped=true&"
import script from "./work-item-form.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-form.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-form.component.vue?vue&type=style&index=0&id=c49266a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49266a0",
  null
  
)

export default component.exports